import { flow, types, getEnv, getRoot } from 'mobx-state-tree'

import { Event } from './'

const Events = types
  .model('EventsModel', {
    items: types.optional(types.map(Event), {}),
  })
  .actions((self) => {
    const {
      services: { eventService },
    } = getEnv(self)

    return {
      add(event) {
        if (!event) {
          return null
        }

        const root = getRoot(self)
        const tournament = event.tournamentDTO

        // For custom events, ensure teamA and teamB are set with default values
        const processedEvent = {
          ...event,
          tournament: tournament.id,
          teamA: event.teamA || '',
          teamB: event.teamB || '',
        }

        self.items.set(event.id, processedEvent)

        root.tournaments.add(tournament)

        return self.items.get(event?.id)
      },

      get(id) {
        return self.items.get(id)
      },

      loadOne: flow(function* (id) {
        if (self.items.has(id)) {
          return self.items.get(id)
        }

        const event = yield eventService.get(id)
        return self.add(event)
      }),

      load: flow(function* (params) {
        const response = yield eventService.query(params)
        const events = response.content.map((event) => self.add(event))

        return {
          response,
          events,
        }
      }),
    }
  })

export const EventsRoot = types.model('EventsRoot', {
  events: types.optional(Events, {}),
})
